module.exports = __webpack_public_path__ + "static/media/terms-of-use.b4fae168.pdf";